<script setup>
const props = defineProps({
  faqSlug: {
    type: String,
    required: true,
  },
})
const { faqSlug } = toRefs(props)
const { data, error } = await useFetch(`/api/faq/${faqSlug.value}/`, {
  query: { 'club-page': true },
})

if (error.value) {
  console.error(error.value)
  throw error.value
}
const faq = computed(() => data.value || [])
const visibleSections = computed(() => {
  if (!faq.value?.sections) return []
  return faq.value.sections.filter((s) => s.questions.length > 0)
})
</script>

<template>
  <div class="site-width">
    <template v-if="faq">
      <h2>{{ faq.header }}</h2>
      <div class="section-faq__accordioans">
        <template v-for="section in visibleSections" :key="section.id">
          <h3>
            {{ section.title }}
          </h3>
          <Accordion v-slot="scope" :multiple="true">
            <AccordionItem
              v-for="question in section.questions"
              :key="question.id"
              :title="question.question_text"
              @expanded="scope.expanded"
            >
              <span v-html="question.answer_text"></span>
            </AccordionItem>
          </Accordion>
        </template>
      </div>
    </template>
  </div>
</template>
